import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { classNames } from "primereact/utils";
import * as Yup from "yup";
import { InputOtp } from "primereact/inputotp";
import emailCode from "../../assets/email-code.png";

const ModalCodigo = (props) => {
  const { modal, callbackModal, callbackSave, email } = props;

  const onClickClose = () => {
    formik.resetForm();
    callbackModal();
  };

  const renderFooterAC = (stateMethod) => {
    return (
      <div className="flex justify-content-center">
        <Button
          label="Cancelar"
          icon="pi pi-times-circle"
          onClick={onClickClose}
          className="p-button-primary"
        />
        <Button
          label="Validar"
          icon="pi pi-check-square"
          type="button"
          severity="success"
          onClick={(e) => {
            formik.handleSubmit();
          }}
        />
      </div>
    );
  };

  const validationSchema = Yup.object().shape({
    codigo: Yup.string()
      .required("Campo requerido.")
      .min(6, "Mínimo: 6 caracteres."),
  });

  const formik = useFormik({
    initialValues: {
      codigo: "",
    },
    validationSchema: validationSchema,
    onSubmit: (data) => {
      callbackSave(data);
    },
  });

  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const isFormFieldValid = (name) => {
    const isValid = !!(formik.touched[name] && formik.errors[name]);
    return isValid;
  };

  const customInput = ({ events, props }) => (
    <input
      key={props.id}
      {...events}
      {...props}
      type="text"
      invalid=""
      unstyled=""
      autoComplete="off"
      className="p-inputotp-input p-inputtext p-component"
    />
  );
  return (
    <div>
      <Dialog
        visible={modal}
        style={{ width: "30vw" }}
        header="Validación"
        modal
        onHide={onClickClose}
        footer={renderFooterAC(null)}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="text-center">
            <img
              src={emailCode}
              alt="Email-code"
              style={{
                width: "150px",
              }}
            />
          </div>
          <div className="text-center">
            Se envió un código al correo registrado:
          </div>
          <div className="text-center">{email}</div>
          <div className="card flex justify-content-center">
            <InputOtp
              id="codigo"
              name="codigo"
              value={formik.values.codigo}
              length={6}
              inputTemplate={customInput}
              autoComplete="off"
              onChange={(e) => {
                formik.setFieldValue("codigo", e.value);
              }}
              integerOnly
              className={classNames({
                "p-invalid": isFormFieldValid("codigo"),
              })}
            />
          </div>
          <div className="text-center">{getFormErrorMessage("codigo")}</div>
        </form>
      </Dialog>
    </div>
  );
};

export default ModalCodigo;
